(function () {
  // Only run once
  if (window.__fb_variant_guard_installed) return;
  window.__fb_variant_guard_installed = true;

  const LOG = false;

  // Helpers
  function qs(sel, root=document) { return root.querySelector(sel); }
  function qsa(sel, root=document) { return Array.from((root||document).querySelectorAll(sel)); }

  // 1) Clear FlyBundles "selected" states that were pre-applied by the app
  function clearFlyBundleDefaults() {
    try {
      const selectedPills = qsa('.gfbFrequentBoughtLabelPillsUISelected');
      if (LOG && selectedPills.length) console.debug('FBT: clearing', selectedPills.length, 'selected pills');
      selectedPills.forEach(p => {
        p.classList.remove('gfbFrequentBoughtLabelPillsUISelected');
        // If they use an attribute for selection, remove that too:
        if (p.hasAttribute('aria-pressed')) p.setAttribute('aria-pressed', 'false');
        // preserve registration but remove visual selected flag
        if (p.dataset && p.dataset.isEventRegistered) p.dataset.isEventRegistered = 'REGISTERED';
      });
    } catch (e) {
      console.warn('FBT clear defaults error', e);
    }
  }

  // helper: detect whether a pill element is visually selected
  function pillIsSelected(pill) {
    if (!pill) return false;
    if (pill.classList.contains('gfbFrequentBoughtLabelPillsUISelected')) return true;
    if (pill.getAttribute('aria-pressed') === 'true') return true;
    // fallback: check active state via attribute or 'selected' class variants
    if (pill.hasAttribute('data-selected') && pill.getAttribute('data-selected') === 'true') return true;
    return false;
  }

  // 2) Return missing group elements within an offer (label container elements)
  function getMissingGroupElements(offerEl) {
    const missing = [];
    try {
      const groups = qsa('.gfbFrequentBoughtWidgetProductContainer', offerEl);
      groups.forEach(group => {
        const labelContainer = group.querySelector('.gfbFrequentBoughtLabelContainer');
        if (!labelContainer) return; // nothing to select

        const pills = qsa('.gfbFrequentBoughtLabelPillsUI', labelContainer);
        if (!pills.length) return; // no choices -> skip

        const hasSelected = pills.some(pillIsSelected);
        // Only enforce for mandatory groups (data-is-mandatory or attribute)
        const isMandatory = group.dataset.isMandatory === 'true' || group.getAttribute('data-is-mandatory') === 'true';
        if (isMandatory && !hasSelected) {
          missing.push(labelContainer);
        }
      });
    } catch (e) {
      if (LOG) console.warn('getMissingGroupElements', e);
    }
    return missing;
  }

  // 3) Basic validator using your original logic but returns missing groups
  function flyBundleValidateWithGroups(offerEl) {
    const missing = getMissingGroupElements(offerEl);
    return { valid: missing.length === 0, missingGroups: missing };
  }

  // 4) Show the app's existing "please select" popup (the widget contains .gfbPopupForMissingSelection)
  function showFBTPopup(offerId) {
    try {
      const popups = qsa('.gfbPopupForMissingSelection[data-offer-id], .gfbPopupForMissingSelection');
      const popup = popups.find(el => {
        return !offerId || el.dataset.offerId == offerId;
      });
      if (popup) {
        popup.style.display = 'block';
        setTimeout(()=> popup.style.display = 'none', 2500);
      } else {
        // fallback
        console.warn('FBT: missing popup element not found');
      }
    } catch (e) { console.warn(e); }
  }

  // create inline error node if not present
  function ensureInlineErrorNode(container) {
    let node = container.querySelector('.gfb-inline-error');
    if (!node) {
      node = document.createElement('div');
      node.className = 'gfb-inline-error';
      node.setAttribute('role', 'alert');
      node.setAttribute('aria-live', 'assertive');
      container.appendChild(node);
    }
    return node;
  }

  // Highlight missing groups + shake + scroll into view
  function highlightMissingGroups(offerEl, missingGroups) {
    try {
      if (!missingGroups || !missingGroups.length) return;

      // Clear any previous highlights from this offer
      offerEl.querySelectorAll('.gfb-missing, .gfb-missing-shake').forEach(el => {
        el.classList.remove('gfb-missing', 'gfb-missing-shake');
        const inline = el.querySelector('.gfb-inline-error');
        if (inline) inline.remove();
      });
      offerEl.querySelectorAll('.gfb-focus-target').forEach(el => el.remove());

      missingGroups.forEach((labelContainer, idx) => {
        const highlightTarget = labelContainer;
        highlightTarget.classList.add('gfb-missing');

        const inlineNode = ensureInlineErrorNode(highlightTarget);
        // Prefer showing the option name if available
        const heading = highlightTarget.querySelector('.gfbFrequentBoughtLabelHeading');
        const optName = heading ? heading.textContent.trim() : null;
        inlineNode.textContent = optName ? `Please select ${optName}` : 'Please select a value for this option';

        if (idx === 0) {
          // add a focus anchor
          let focusTarget = document.createElement('button');
          focusTarget.type = 'button';
          focusTarget.className = 'gfb-focus-target';
          highlightTarget.appendChild(focusTarget);

          // Shake + scroll into view
          highlightTarget.classList.add('gfb-missing-shake');
          setTimeout(()=> {
            try {
              highlightTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
              focusTarget.focus({ preventScroll: true });
            } catch(e){
              highlightTarget.scrollIntoView();
            }
          }, 60);
        }
      });

      // remove temporary shake class after animation completes
      setTimeout(()=> {
        offerEl.querySelectorAll('.gfb-missing-shake').forEach(el => el.classList.remove('gfb-missing-shake'));
      }, 700);

      // auto-clear highlights after 6s
      setTimeout(()=> {
        try {
          offerEl.querySelectorAll('.gfb-missing').forEach(el => {
            const inline = el.querySelector('.gfb-inline-error');
            if (inline) inline.remove();
            el.classList.remove('gfb-missing');
          });
          offerEl.querySelectorAll('.gfb-focus-target').forEach(ft => ft.remove());
        } catch (e) {}
      }, 6000);

    } catch (e) {
      if (LOG) console.warn('highlightMissingGroups error', e);
    }
  }

  // 5) Intercept Fly Add-to-Cart and theme add-to-cart to block when bundle selections missing
  function attachGuards() {
    // theme button - only block if any FBT offers missing selections
    const addBtn = qs('.add-to-cart-btn');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        try {
          const anyFBT = qsa('.gfbFrequentBoughtWidgetOfferContainer');
          if (!anyFBT.length) return; // nothing to validate

          for (let offer of anyFBT) {
            const { valid, missingGroups } = flyBundleValidateWithGroups(offer);
            if (!valid) {
              e.preventDefault();
              e.stopImmediatePropagation();
              showFBTPopup(offer.dataset.offerId);
              highlightMissingGroups(offer, missingGroups);
              if (LOG) console.debug('FBT: blocked theme add-to-cart due to missing selection');
              return false;
            }
          }
        } catch (err) {
          if (LOG) console.warn(err);
        }
      }, true);
    }

    // FlyBundles own add-to-cart
    qsa('.gfbFrequentBoughtAddToCartButton').forEach(btn => {
      btn.addEventListener('click', function (e) {
        try {
          const offerId = btn.dataset.offerId;
          const offerEl = btn.closest('.gfbFrequentBoughtWidgetOfferContainer') || document;
          const { valid, missingGroups } = flyBundleValidateWithGroups(offerEl);
          if (!valid) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showFBTPopup(offerId);
            highlightMissingGroups(offerEl, missingGroups);
            if (LOG) console.debug('FBT: blocked fly add-to-cart for offer', offerId);
            return false;
          }
        } catch (err) {
          if (LOG) console.warn(err);
        }
      }, true);
    });
  }

  // 6) One-time init - clear defaults and attach guards
  function initOnce() {
    clearFlyBundleDefaults();
    attachGuards();
  }

  // Run on DOMContentLoaded and also after a short delay (app may render late)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ()=> {
      setTimeout(initOnce, 400); // give fly a tick
    });
  } else {
    setTimeout(initOnce, 400);
  }

  // MutationObserver fallback: if fly renders after our initial run, do a one-time patch
  const obsTarget = document.body;
  let patched = false;
  const obs = new MutationObserver((mutations)=> {
    if (patched) { obs.disconnect(); return; }
    const found = document.querySelector('.gfbFrequentBoughtWidgetOfferContainer, .gfbFrequentBoughtWidgetContainer');
    if (found) {
      patched = true;
      // run patch after microtask to allow app to finish rendering internals
      setTimeout(()=> {
        clearFlyBundleDefaults();
        attachGuards();
      }, 200);
      obs.disconnect();
    }
  });
  obs.observe(obsTarget, { childList: true, subtree: true });

  // safety: disconnect observer after 8s to avoid long-running observers
  setTimeout(()=> obs.disconnect(), 8000);
})();